<template>
  <div
    class="rating-card"
    :class="{ 'is-list': isList }"
    @click="seeRatingDetail"
  >
    <div class="rating-card__content">
      <div class="rating-card__top">
        <div class="rating-card__info">
          <div class="rating-card__wrap">
            <div class="rating-card__user-name">
              {{ rating.anonymousName }}
            </div>
            <span class="rating-card__caption rating-card__caption--divider">|</span>
            <span class="rating-card__caption">{{ rating.place }}</span>
          </div>
          <div class="rating-card__caption">
            {{ rating.time }}
          </div>
        </div>
        <div class="rating-card__wrap">
          <div class="rating-card__stars">
            <i
              v-for="n in calculateStarsAmount(rating.score)[0]"
              :key="`f-${n}`"
              class="rating-card__star-icon icon-star-filled"
            />
            <i
              v-for="n in calculateStarsAmount(rating.score)[1]"
              :key="`h-${n}`"
              class="rating-card__star-icon icon-star-half-filled"
            >
              <span class="path1" />
              <span class="path2" />
            </i>
            <i
              v-for="n in calculateStarsAmount(rating.score)[2]"
              :key="`e-${n}`"
              class="rating-card__star-icon icon-star-filled rating-card__star-icon--empty"
            />
          </div>
        </div>
      </div>
      <div
        class="rating-card__review"
        :class="{ 'fixed-height': !isList }"
      >
        <div
          class="rating-card__text"
          :class="{ 'is-hidden': !isList }"
        >
          {{ rating.note }}
        </div>
        <div
          v-if="rating.pictureList.length && isMobile && !isList"
          :style="`background-image:url(${rating.pictureList[0]})`"
          class="rating-card__image"
          @click.stop="openImageViewer(rating.pictureList, 0)"
        >
          <template v-if="rating.pictureList.length > 1">
            <div class="rating-card__image-mask" />
            <span class="rating-card__image-count">
              +{{ rating.pictureList.length }}
            </span>
          </template>
        </div>
      </div>
      <div
        v-if="(!isMobile || isList)"
        :class="{ 'rating-card__bottom': !isList && !isMobile, 'rating-card__bottom-wrap': isList}"
      >
        <div
          v-if="rating.pictureList.length"
          class="rating-card__image-wrap"
        >
          <div
            v-for="(item, itemIndex) in rating.pictureList"
            :key="item"
            :style="`background-image:url(${item})`"
            class="rating-card__image"
            @click.stop="openImageViewer(rating.pictureList, itemIndex)"
          />
        </div>
        <div
          v-if="rating.tagList.length"
          class="rating-card__tags"
        >
          <div
            v-for="(tag, tagIndex) in rating.tagList"
            :key="rating.order_id + tag.TagName + tagIndex"
            class="rating-card__tag"
          >
            <span class="rating-card__tag-text">{{ tag.TagName }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { calculateStarsAmount } from '@/utils/rating'
export default {
  name: 'RatingCard',

  props: {
    rating: {
      type: Object,
      required: true
    },
    isList: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['isMobile'])
  },
  methods: {
    calculateStarsAmount,
    seeRatingDetail () {
      this.$emit('click', this.rating.order_id)
    },
    openImageViewer (imageList, index) {
      this.$store.dispatch('imageBrowser', {
        isOpen: true,
        imageList,
        activeIndex: index
      })
    }
  }
}
</script>

<style scoped lang="scss">
.rating-card {
  min-height: 324px;
  position: relative;
  cursor: pointer;

  &.is-list {
    min-height: 110px;
    cursor: initial;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: pxTorem(12px);
  }

  &__top {
    display: flex;
    flex-direction: column;
    gap: pxTorem(12px);
  }

  &__info {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__wrap {
    display: flex;
  }

  &__user-name {
    font-weight: 600;
  }

  &__caption {
    font-size: pxTorem(15px);
    color: $color-caption;

    &--divider {
      margin-left: 4px;
      margin-right: 4px;
    }
  }

  &__stars {
    display: flex;
    gap: 2px;
  }

  &__star-icon {
    font-size: pxTorem(18px);
    color: $color-rating;
    display: flex;

    &--empty {
      color: $color-background-primary;
    }
  }

  &__review {
    &.fixed-height {
      height: calc(1.5rem * 3);
    }
  }

  &__bottom {
    position: absolute;
    bottom: 0;
    display: flex;
    flex-direction: column;
    gap: 28px;
  }

  &__bottom-wrap {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__text {
    word-break: break-all;

    &.is-hidden {
      height: calc(1.5rem * 3);
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }
  }

  &__image {
    position: relative;
    width: 80px;
    height: 80px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-color: gray;
    border-radius: 4px;
    cursor: pointer;
  }

  &__image-wrap {
    display: flex;
    gap: pxTorem(8px);
    overflow: hidden;
  }

  &__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  &__tag {
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 8px;
    padding-bottom: 8px;
    border-radius: 100px;
    background-color: $color-background-primary;
  }

  &__tag-text {
    font-size: 13px;
    font-weight: 600;
  }

  &__image-mask {
    position: absolute;
    inset: 0px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  &__image-count {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: $color-text-inverse;
    z-index: 5;
  }
}

@media screen and (max-width: 768px) {
  .rating-card {
    min-height: 145px;

    &__user-name {
      font-size: 15px;
    }

    &__caption {
      font-size: 13px;
    }

    &__star-icon {
      font-size: 16px;
    }

    &__review {
      display: flex;
      justify-content: space-between;
      gap: 16px;
      margin-top: 0;
    }

    &__text {
      font-size: 14px;

      &.is-hidden {
        height: calc(14px * 1.5 * 3);
      }
    }

    &__image {
      position: relative;
      width: 67px;
      height: 67px;
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

</style>
